<template>
  <div :class="showAvailableCount ? '' : 'hide-available-count'">
    <div class="flex flex-row justify-end items-baseline">
      <CustomIonPopover css-class="grouping-tooltip-popover" :disabled="!showGroupingTooltip">
        <template #popoverContent>
          <div class="flex flex-row items-start gap-1 text-xxxs italic color-tertiary">
            <div>*</div>
            <div>Multiple records are grouped together</div>
          </div>
        </template>
        <template #popoverReference>
          <div class="text-m font-semibold color-tertiary">
            {{ filteredCountDisplay }}<span v-if="showGroupingTooltip">*</span>
          </div>
        </template>
      </CustomIonPopover>
      <div>
        <span class="color-medium px-1">|</span>
        <span class="text-xs color-text"> {{ currentCountDisplay }}</span>
      </div>
      <div v-if="showAvailableCount" class="get-more-records-button ms-2">
        <CustomSimpleButton :isDisabled="disableGetMoreRecords" @onClick="onGetMoreRecordsClicked">
          <span class="text-xs" :class="disableGetMoreRecords ? 'color-medium' : 'color-tertiary'">
            More
            <i class="ti ti-caret-right"></i>
          </span>
        </CustomSimpleButton>
      </div>
    </div>
    <div
      v-if="showAvailableCount"
      class="available-count text-end italic text-xxs color-medium-dark"
    >
      <span v-if="fetchedCount === availableCount">
        Loaded all {{ availableCountDisplay }} records<template v-if="showGroupingTooltip">
          (grouped into {{ currentCountDisplay }})</template
        >
      </span>
      <span v-else>Loaded {{ fetchedCountDisplay }} / {{ availableCountDisplay }} records</span>
    </div>
  </div>
</template>

<script lang="ts">
import CustomIonPopover from "@/components/ionic/CustomIonPopover.vue";
import CustomSimpleButton from "@/components/primitives/CustomSimpleButton.vue";
import { getFormattedNumber } from "@/methods/utils";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "CardsListCounter",
  components: { CustomSimpleButton, CustomIonPopover },
  props: {
    filteredCount: { type: Number, required: true },
    currentCount: { type: Number, required: true },
    fetchedCount: { type: Number, default: null },
    availableCount: { type: Number, default: null },
    showAvailableCount: { type: Boolean, default: false },
    disableGetMoreRecords: { type: Boolean, default: false },
    dataLoading: { type: Boolean, default: false },
  },
  emits: ["getMoreRecords"],
  setup(props, { emit }) {
    const showGroupingTooltip = computed(() => {
      return props.fetchedCount !== null && props.fetchedCount !== props.currentCount;
    });
    const filteredCountDisplay = computed(() => {
      if (props.filteredCount === 0) {
        return 0;
      }
      return getFormattedNumber(props.filteredCount, 0);
    });

    const currentCountDisplay = computed(() => {
      return props.currentCount ? getFormattedNumber(props.currentCount, 0) : null;
    });

    const fetchedCountDisplay = computed(() => {
      return props.fetchedCount ? getFormattedNumber(props.fetchedCount, 0) : null;
    });

    const availableCountDisplay = computed(() => {
      return props.availableCount ? getFormattedNumber(props.availableCount, 0) : null;
    });

    function onGetMoreRecordsClicked() {
      if (props.disableGetMoreRecords) {
        return;
      }
      emit("getMoreRecords");
    }
    return {
      showGroupingTooltip,
      filteredCountDisplay,
      currentCountDisplay,
      fetchedCountDisplay,
      availableCountDisplay,
      onGetMoreRecordsClicked,
    };
  },
});
</script>
<style lang="scss">
.grouping-tooltip-popover {
  --width: 130px;
  --max-width: 130px;
}
</style>
